@if (count > 0) {
  <button type="button" class="likers" [class.likers--compact]="compact" aria-haspopup="dialog" (click)="open()">
    @if (compact) {
      <span class="likers__text">{{ count | utNumToK }} {{ count === 1 ? 'like' : 'likes' }}</span>
    } @else {
      @if (preview.length) {
        <span class="likers__stack" aria-hidden="true">
          @for (liker of preview; track liker.id) {
            <ut-avatar-badges class="likers__avatar" [user]="liker"></ut-avatar-badges>
          }
        </span>
      } @else {
        <span class="material-icons likers__icon" aria-hidden="true">favorite</span>
      }
      <span class="likers__text">
        @if (onlyYou) {
          You liked this
        } @else if (leadName) {
          Liked by <b>{{ leadName }}</b>
          @if (othersCount > 0) {
            &ngsp;and {{ othersCount | utNumToK }} {{ othersCount === 1 ? 'other' : 'others' }}
          }
        } @else {
          {{ count | utNumToK }} {{ count === 1 ? 'like' : 'likes' }}
        }
      </span>
    }
  </button>
} @else if (showEmpty) {
  <span class="likers likers--empty">No likes yet</span>
}
